import { useLayoutEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import HomeMarkup from '../components/home/generated/HomeMarkup'
import { HOME_SEO } from '../config/seo'
import { usePageCss } from '../hooks/usePageCss'
import { usePageMeta } from '../hooks/usePageMeta'
import { runHomeEnhancements } from './home-runtime'

export default function Home() {
  const navigate = useNavigate()
  if (typeof document !== 'undefined') {
    document.documentElement.setAttribute('data-home-page', 'true')
    document.documentElement.setAttribute('data-theme', 'dark')
  }
  usePageMeta(HOME_SEO)
  usePageCss('home-page-css', '/css/lighter_home.css')

  useLayoutEffect(() => {
    document.documentElement.setAttribute('data-home-page', 'true')
    document.documentElement.setAttribute('data-theme', 'dark')

    const root = document.getElementById('main')
    const stop = runHomeEnhancements(root, navigate)

    return () => {
      stop()
      document.documentElement.removeAttribute('data-home-page')
    }
  }, [navigate])

  return (
    <div className="home-page">
      <HomeMarkup />
    </div>
  )
}
